var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{g_loadIcon:true, white:_vm.white}})}
var staticRenderFns = []

export { render, staticRenderFns }